export let PopupSettings: any = {
  POPUP_CUST: {
    title: "거래처도움창",
    // 없으면 기본 50%, 단위는 % 또는 px
    width: "50%",
    // 없으면 기본 90%, 단위는 % 또는 px
    height: "90%",
    // columns의 0번 index는 code, 1번 index는 name
    columns: [
      "cd_cust",
      "nm_cust_sort",
      "nm_cust",
      "no_biz",
      "fg_account",
      "tp_payterm",
    ],
    // 팝업 생성 시, 검색창에 자동 입력할 데이터의 key값
    str_search: "cd_cust",
    autoSearch: false,
    // 멀티 속성을 사용할 메뉴 코드
    isMultiple: [""],
  },
  POPUP_ITEM: {
    title: "품목도움창",
    // columns의 0번 index는 code, 1번 index는 name
    width: "65%",
    columns: [
      "cd_item",
      "nm_item",
      "dc_item_spec",
      "dc_item_unit",
      "dc_material",
      "yn_lot",
      "yn_sn",
      "cd_cust_maker",
      "cd_cust_isu",
      "cd_cust_rcv",
      "fg_vat",
      "fg_unit",
      "dc_unit_po",
      "qt_unit_po",
      "tp_item", // 26.03.24 kdy 마이라텍스때 추가
      "nm_model",
    ],
    // 팝업 생성 시, 검색창에 자동 입력할 데이터의 key값
    str_search: "cd_item",
    autoSearch: false,
    isMultiple: ["SN_SAL_SAO_REG_001", "SN_SAL_SAO_REG_001_TEX"],
  },
  POPUP_ITEM_02: {
    title: "품목도움창",
    // columns의 0번 index는 code, 1번 index는 name
    width: "65%",
    columns: [
      "cd_item",
      "nm_item",
      "dc_item_spec",
      "dc_item_unit",
      "cd_dummy04",
      "cd_dummy01",
      "cd_dummy02",
      "cd_dummy03",
      "dc_material",
    ],
    // 팝업 생성 시, 검색창에 자동 입력할 데이터의 key값
    str_search: "cd_item",
    autoSearch: false,
    isMultiple: ["SN_PMS_BAS_REG_004"],
  },
  POPUP_EMP: {
    title: "사원도움창",
    // "key" : ["cd_firm", "cd_emp"],
    columns: ["cd_emp", "nm_emp", "cd_dept", "nm_dept", "cd_gp", "nm_gp"],
    str_search: "cd_emp",
    isMultiple: [""],
  },
  POPUP_MEET: {
    title: "회의록도움창",
    width: "60%",
    // columns의 0번 index는 code, 1번 index는 name
    columns: ["no_meeting", "nm_meeting", "dt_meeting", "nm_cust"],
    str_search: "no_meeting",
    isMultiple: [""],
  },
  POPUP_STYLE: {
    title: "스타일도움",
    // "key" : ["cd_firm", "no_style"],
    columns: ["no_style", "nm_style", "tp_item", "dc_dummy01"],
    str_search: "no_style",
    isMultiple: [""],
  },
  POPUP_WH: {
    title: "창고도움창",
    // "key" : ["cd_firm", "cd_emp"],
    columns: ["cd_wh", "nm_wh"],
    str_search: "cd_wh",
    isMultiple: [""],
  },
  POPUP_WH_BF: {
    title: "공정창고도움창",
    // "key" : ["cd_firm", "cd_emp"],
    columns: ["cd_wh", "nm_wh"],
    str_search: "cd_wh",
    isMultiple: [""],
  },
  POPUP_WH_ALL: {
    title: "전체창고도움창",
    columns: ["cd_wh", "nm_wh"],
    str_search: "cd_wh",
    isMultiple: [""],
  },
  POPUP_ACCT: {
    title: "계정코드도움창",
    columns: ["cd_acct", "nm_acct"],
    str_search: "cd_acct" /*"nm_acct",*/,
    isMultiple: [""],
  },
  POPUP_ACT: {
    title: "Activity 도움창",
    columns: [
      "cd_activity",
      "nm_activity",
      "fg_wbs",
      "tp_work",
      "fg_work",
      "nm_fg_pjt",
      "nm_fg_wbs",
      "nm_tp_work",
      "nm_fg_work",
      "nm_yn_use",
    ],
    str_search: "cd_activity" /*"nm_activity",*/,
    isMultiple: [""],
  },
  POPUP_APNTCODE: {
    title: "발령 정보조회",
    columns: ["cd_apnt", "nm_apnt"],
    str_search: "cd_apnt" /*"nm_apnt",*/,
    isMultiple: [""],
  },
  POPUP_NO_MGMT: {
    title: "관리번호도움창",
    columns: ["no_mgmt", "cd_cust_bank", "nm_cust_bank", "fg_account"],
    str_search: "no_mgmt",
  },
  POPUP_BANK: {
    title: "금융기관도움창",
    columns: ["cd_cust_bank", "nm_cust_bank"],
    str_search: "cd_cust_bank",
  },
  POPUP_BIZ: {
    title: "사업장 도움창",
    columns: ["cd_biz", "nm_biz"],
    str_search: "cd_biz" /*"nm_biz",*/,
    isMultiple: [""],
  },
  POPUP_CATAGORY: {
    title: "제품분류 도움창",
    columns: ["cd_mgmt", "nm_mgmt"],
    str_search: "cd_mgmt" /*"nm_mgmt",*/,
  },
  POPUP_CB: {
    title: "CB 도움창",
    columns: ["cd_cb", "nm_cb"],
    str_search: "cd_cb" /*"nm_cb",*/,
    isMultiple: [""],
  },
  POPUP_CC: {
    title: "C/C 도움창",
    columns: ["cd_cc", "nm_cc"],
    str_search: "cd_cc" /*"nm_cc",*/,
  },
  POPUP_CODE: {
    title: "공통코드",
    columns: ["code", "name"],
    str_search: "cd_flag" /*"nm_flag",*/,
    isMultiple: [""],
  },
  POPUP_CODE2: {
    title: "코드 도움창",
    columns: ["code", "name"],
    str_search: "cd_flag" /*"nm_flag",*/,
    isMultiple: [""],
  },
  POPUP_DEPT: {
    title: "부서 도움창",
    columns: ["cd_dept", "nm_dept"],
    str_search: "cd_dept" /*"nm_dept",*/,
    isMultiple: [""],
  },
  POPUP_GP: {
    title: "그룹 도움창",
    columns: ["cd_gp", "nm_gp"],
    str_search: "cd_gp" /*"nm_gp",*/,
    isMultiple: [""],
  },
  POPUP_ITEMGRP: {
    title: "품목군 도움창",
    columns: [
      "cd_group",
      "nm_group",
      "no_level",
      "nm_group_level",
      "nm_group_p",
    ],
    str_search: "cd_group" /*"no_level", "nm_group_level", "nm_group_p",*/,
  },
  POPUP_PJT: {
    title: "PJT 도움창",
    columns: ["cd_pjt", "nm_pjt", "cd_pjtgrp", "nm_pjtgrp", "nm_st_pjt"],
    str_search: "cd_pjt" /*"nm_pjt", "nm_pjtgrp",*/,
    isMultiple: [""],
    excludeBindKeys: ["cd_cust"], // 선택한 로우에서 제외시키고 싶은 컬럼 설정
  },
  POPUP_EQUIP: {
    title: "설비 도움창",
    columns: ["cd_equip", "nm_equip", "nm_equip_sort", "yn_use"],
    str_search: "cd_equip" /*"nm_equip", "nm_equip_sort",*/,
    isMultiple: [""],
  },
  POPUP_OP: {
    title: "공정코드 도움창",
    columns: ["cd_op", "nm_op"],
    str_search: "cd_op" /*"nm_op",*/,
    isMultiple: [""],
  },
  POPUP_ROUT: {
    title: "공정경로 도움창",
    columns: ["cd_rout", "nm_rout"],
    str_search: "cd_rout" /*"nm_rout",*/,
    isMultiple: [""],
  },
  POPUP_WC: {
    title: "작업장 도움창",
    columns: ["cd_wc", "nm_wc"],
    str_search: "cd_wc" /*"nm_wc",*/,
    isMultiple: [""],
  },
  POPUP_LOCATION: {
    title: "Location 도움창",
    columns: ["cd_loc", "nm_wh", "yn_stack"],
    str_search: "cd_loc",
  },
  POPUP_VCR: {
    title: "VCR 도움창",
    columns: [
      "cd_firm",
      "no_app",
      "nm_doc",
      "yn_app",
      "dt_app",
      "dt_write",
      "nm_emp_u",
    ],
    //"str_search" : ["", ""],
  },
  POPUP_CUST_DELIVERY: {
    title: "납품처도움창",
    columns: ["cd_cust_dlv", "nm_cust_dlv", "dc_address", "dc_address_detail"],
    str_search: "cd_cust_dlv",
  },
  POPUP_CUST_SCT: {
    title: "외주처도움창",
    columns: [
      "cd_cust",
      "nm_cust_sort",
      "nm_cust",
      "no_biz",
      "nm_boss",
      "dc_address",
    ],
    str_search:
      "cd_cust" /*"nm_cust", "nm_cust_sort", "no_biz", "nm_boss", "dc_address",*/,
  },
  POPUP_DGCODE: {
    title: "근태 정보조회",
    columns: ["cd_dgcode", "nm_dg"],
    str_search: "cd_dgcode" /*"nm_dg",*/,
  },
  POPUP_EDUCODE: {
    title: "교육과정 정보조회",
    columns: ["cd_edu", "nm_edu"],
    str_search: "cd_edu" /*"nm_edu",*/,
  },
  POPUP_ENR: {
    title: "소득자 조회",
    columns: ["cd_enr", "nm_enr"],
    str_search: "cd_enr" /*"nm_enr",*/,
  },
  POPUP_FIN_ACCT: {
    title: "계정 도움창",
    columns: ["cd_acct", "nm_acct"],
    str_search: "cd_acct" /*"nm_acct",*/,
  },
  POPUP_FIN_ACCTGROUP: {
    title: "계정그룹도움창",
    columns: ["cd_group", "no_level", "nm_group"],
    str_search: "cd_group" /*"nm_group",*/,
  },
  POPUP_FIN_CARD: {
    title: "신용카드도움창",
    columns: ["no_card", "nm_fg_card", "nm_card"],
    str_search: "no_card" /*"nm_card",*/,
  },
  POPUP_FIN_CODEH: {
    title: "관리항목도움창",
    columns: ["cd_code", "nm_code"],
    str_search: "cd_code" /*"nm_code",*/,
  },
  POPUP_FIN_FUNDCODE: {
    title: "자금과목도움창",
    columns: ["cd_fund", "nm_fund", "nm_fg_income"],
    str_search: "cd_fund" /*"nm_fund",*/,
  },
  POPUP_FIRMMENU: {
    title: "메뉴도움창",
    // "columns" : ["cd_fund", "nm_fund", "nm_fg_income"],
    // "str_search" : ["cd_fund","nm_fund"],
  },
  POPUP_HRSLCTR: {
    title: "강사 정보조회",
    columns: ["cd_lctr", "nm_lctr"],
    str_search: "cd_lctr" /*"nm_lctr",*/,
  },
  POPUP_COUNTRY: {
    title: "Country 정보조회",
    columns: ["cd_country", "nm_country"],
    str_search: "cd_country" /*"nm_country",*/,
  },
  POPUP_MGMT: {
    title: "관리내역 도움창",
    columns: ["cd_mgmtdtl", "nm_mgmtdtl"],
    str_search: "cd_mgmtdtl" /*"nm_mgmtdtl",*/,
    isMultiple: [""],
  },
  POPUP_PALLET: {
    title: "PALLET 조회",
    columns: ["cd_loc", "nm_loc", "cd_plt", "nm_plt"],
    //"str_search" : ["",""],
    isMultiple: [""],
  },
  POPUP_CUSTITEM: {
    title: "거래처품목도움창",
    width: "65%",
    // 그리드 코드 칸 직접 입력 조회(_02/_03)에 행의 이 값들을 함께 넘긴다 (도움창 조회처럼 거래처 · 품목으로 거르기)
    filterParams: ["cd_cust", "cd_item"],
    columns: [
      "cd_item_cust",
      "nm_item_cust",
      "dc_item_spec_cust",
      "cd_item",
      "nm_item",
      "dc_item_spec",
      "dc_item_unit",
      "nm_model",
      "tp_item",
      "dc_material",
      // "no_seq",
      "nm_cust_maker",
      "fg_vat",
    ],
    str_search:
      "cd_item_cust" /*"nm_item_cust","dc_item_spec_cust","cd_item","nm_item","dc_item_spec","nm_model",*/,
    isMultiple: [""],
  },
  POPUP_BUDGET: {
    title: "예산도움창",
    columns: [
      "cd_budget",
      "nm_budget",
      "fg_pjt",
      "nm_fg_pjt",
      "fg_budget",
      "nm_fg_budget",
      "tp_budget",
      "nm_tp_budget",
      "fg_mgmt",
      "nm_fg_mgmt",
      "yn_use",
      "nm_yn_use",
    ],
    str_search: "cd_budget" /*"nm_budget",*/,
    isMultiple: [""],
  },
  POPUP_HRSDEDUCT: {
    title: "공제 정보조회",
    columns: ["cd_deduct", "nm_deduct"],
    str_search: "cd_deduct" /*"nm_deduct",*/,
  },
  POPUP_LEDGERACCOUNT: {
    title: "계정과목 정보조회",
    columns: ["ledgeraccount", "ledgeraccountname"],
    str_search: "ledgeraccount" /*"ledgeraccountname",*/,
    isMultiple: [""],
  },
  POPUP_NAMECARD01: {
    title: "담당자 도움",
    columns: [
      "nm_person",
      "nm_dept",
      "nm_duty",
      "nm_role",
      "no_hp",
      "dc_email",
      "txt_memo",
      "yn_use",
      "nm_user_reg",
      "tm_reg",
      "nm_user_amd",
      "tm_amd",
    ],
    str_search: "nm_person" /*"nm_dept", "nm_duty",*/,
  },
  POPUP_GPMENU: {
    title: "그룹메뉴도움",
    columns: ["cd_gpmenu", "nm_gpmenu"],
    str_search: "cd_gpmenu" /*"nm_gpmenu",*/,
  },
  POPUP_PRD_WO: {
    title: "작업지시 도움",
    columns: [
      "no_wo",
      "dt_wo",
      // "dt_end",
      // "cd_item",
      // "nm_item",
      // "dc_item_spec",
      // "dc_item_unit",
      // "qt_wo",
      // "nm_st_wo",
      // "nm_rout",
      // "nm_fg_wo",
      // "nm_emp",
      // "qt_work",
      // "nm_mgmtdtl",
      // "dc_rmk",
    ],
    //"str_search" : ["", ""],
  },
  POPUP_ACTIVITY_DTL: {
    title: "작업지시 도움",
    columns: ["cd_activity_dtl", "nm_activity_dtl"],
    str_search: "cd_activity_dtl" /*"nm_activity_dtl",*/,
  },
  POPUP_CLS: {
    title: "조건정보조회",
    columns: ["code", "name"],
    str_search: ["code", "name"],
  },
  POPUP_CONCODE: {
    title: "조건 정보조회",
    columns: ["nm_cgroup", "nm_work", "cd_cond", "nm_cond"],
    //"str_search" : ["nm_cgroup", "nm_work", "cd_cond", "nm_cond"],
    isMultiple: [""],
  },
  POPUP_CONCODE2: {
    title: "코드정보조회",
    columns: ["code", "name"],
    //"str_search" : ["code", "name"],
  },
  POPUP_DEDUCT: {
    title: "소득자구분 조회",
    columns: ["cd_deduct", "nm_deduct"],
    //"str_search" : ["cd_deduct", "nm_deduct"],
  },
  POPUP_ITEMGROUP: {
    title: "품목군 도움창",
    columns: ["cd_group", "nm_group"],
    str_search: "cd_group" /*"nm_group",*/,
    isMultiple: [""],
  },
  POPUP_SOTYPE: {
    title: "수주형태도움창",
    columns: ["cd_so", "nm_so"],
    str_search: "cd_so" /*"nm_so",*/,
    isMultiple: [""],
  },
  POPUP_SFA_CONTRACTH: {
    title: "계약적용",
    columns: ["nm_cust", "nm_contract", "dt_contract", "dt_warranty_valid"],
    //"str_search" : ["nm_cust", "nm_contract", "dt_contract", "dt_warranty_valid"],
  },
  POPUP_SOURCE01: {
    title: "거래처정보도움",
    columns: [
      "fg_source",
      "nm_source",
      "nm_ceo",
      "dc_address",
      "dc_address_detail",
      "fg_source2",
      "cd_eval",
      "cd_cust",
      "yn_use",
      "cd_user_reg",
      "tm_reg",
      "cd_user_amd",
      "tm_amd",
    ],
    //"str_search" : ["fg_source", "nm_source", "nm_ceo", "dc_address", "dc_address_detail", "fg_source2", "cd_eval", "cd_cust", "yn_use", "cd_user_reg", "tm_reg", "cd_user_amd", "tm_amd"],
  },
  POPUP_PERSON: {
    title: "프로젝트 도움",
    columns: [
      "nm_person",
      "nm_agnet",
      "no_tel",
      "no_hp",
      "dc_address",
      "dc_address_detail",
      "no_id",
      "cd_person",
      "dc_email",
      "no_post",
      "fg_person",
      "fg_reg",
      "dc_cust",
    ],
    str_search: "nm_person" /*"cd_person", "no_hp", "no_tel", "no_id",*/,
    isMultiple: [""],
  },
  POPUP_PRT_TOOL: {
    title: "품목 조회",
    columns: ["no_tool", "nm_tool"],
    str_search: "no_tool" /*"nm_tool",*/,
  },
  POPUP_PRT_OP: {
    title: "Operation Search",
    columns: ["cd_op", "nm_op"],
    str_search: "cd_op" /*"nm_op",*/,
    isMultiple: [""],
  },
  POPUP_TMCARDIOINFO: {
    title: "계정과목 정보조회",
    columns: ["no_card", "cd_emp", "nm_emp", "dt_start", "dt_end"],
    str_search: "no_card" /*"cd_emp", "nm_emp", "dt_start", "dt_end",*/,
    isMultiple: [""],
  },
  POPUP_IOTYPE: {
    title: "수불형태도움창",
    columns: ["cd_io", "nm_io"],
    str_search: "cd_io" /*"nm_io",*/,
    isMultiple: [""],
  },
  POPUP_PARTNER: {
    title: "Partner Search",
    columns: [
      "cd_partner",
      "nm_partner_eng",
      "nm_partner_short",
      "dc_address_bl",
      "no_tel",
      "tp_partner",
      "cd_accountid",
    ],
    str_search:
      "cd_partner" /*"nm_partner_eng",, "nm_partner_short", "dc_address_bl", "no_tel", "tp_partner", "cd_accountid"*/,
  },
  POPUP_PCALC: {
    title: "계산식도움창",
    //"columns" : ["nm_cgroup", "nm_work", "nm_pd", "cd_pay", "nm_pay", "cd_cond", "nm_cond"],
    //"str_search" : "nm_cgroup",  /*"nm_work",, "nm_pd", "cd_pay", "nm_pay", "cd_cond", "nm_cond"*/
  },
  POPUP_PDCODE: {
    title: "정보조회",
    columns: ["cd_pay", "nm_pay"],
    str_search: "cd_pay" /*"nm_pay",*/,
  },
  POPUP_PFORM: {
    title: "양식 정보조회",
    columns: ["cd_form", "nm_form"],
    str_search: "cd_form" /*"nm_form",*/,
  },
  POPUP_PRD_TOOL: {
    title: "Tool 도움창",
    columns: ["no_tool", "nm_tool"],
    str_search: "no_tool" /*"nm_tool",*/,
  },
  POPUP_PRT_EQUIP: {
    title: "Equipment Search",
    columns: ["no_seq", "cd_equip", "nm_equip", "nm_op", "nm_op_p", "yn_use"],
    str_search:
      "no_seq" /*"cd_equip",, "nm_equip", "nm_op", "nm_op_p", "yn_use"*/,
  },
  POPUP_PRT_OP_DETAIL: {
    title: "작업내역 도움창",
    columns: ["nm_op_detail", "cd_op_detail"],
    str_search: "nm_op_detail" /*"cd_op_detail",*/,
  },
  POPUP_PRT_PATTERN: {
    title: "목형 조회",
    columns: ["cd_pattern", "nm_pattern"],
    str_search: "cd_pattern" /*"nm_pattern",*/,
  },
  POPUP_PRT_PROC_EMP: {
    title: "EMPLOYEE POPUP",
    columns: ["cd_emp", "nm_emp"],
    str_search: "cd_emp" /*"nm_emp",*/,
  },
  POPUP_POSTCODE: {
    title: "우편번호 조회",
    width: "600px",
    height: "570px",
    columns: ["no_post", "nm_post", "dc_address"],
  },
  POPUP_PASSWORD: {
    title: "비밀번호 변경",
    columns: ["no_pwd"],
  },
  POPUP_RECIPIENT: {
    title: "RECIPIENTS HELP POPUP",
    width: "60%",
    columns: ["cd_emp", "nm_emp"],
  },
  POPUP_REFERENCE: {
    title: "REFERENCES HELP POPUP",
    width: "60%",
    columns: ["cd_emp", "nm_emp"],
  },
  /**
   * 메뉴 다중선택 도움창 — MenuMultiPopup 이 그린다.
   *
   * 목록을 전역 메뉴 스토어에서 읽으므로 조회쿼리(_01)·검증쿼리(_02/_03)가 없다.
   * noLookup 으로 blur 때마다 없는 쿼리를 부르지 않게 막는다.
   */
  POPUP_MENU_MULTI: {
    title: "메뉴 도움창",
    width: "50%",
    height: "70%",
    // 0번이 code, 1번이 name
    columns: ["cd_menu", "nm_menu"],
    str_search: "nm_menu",
    noLookup: true,
  },
  POPUP_MENU: {
    title: "NOTESMENU HELP POPUP",
    width: "65%",
    columns: ["cd_menu", "nm_menu"],
    str_search: "cd_menu",
  },
  // SN_MAS_SET_REG_007 알람 메뉴 코드도움창 (cd_menu/nm_menu 통합검색)
  POPUP_ALARM_MENU: {
    title: "메뉴 도움창",
    width: "50%",
    columns: ["cd_menu", "nm_menu"],
    str_search: "str_search",
    autoSearch: true,
  },
  POPUP_SFA_PJT: {
    title: "프로젝트관리 도움",
    columns: [
      "cd_pjt",
      "nm_pjt",
      "dt_start_p",
      "dt_end_p",
      "st_pjt",
      "fg_label",
      "nm_emp_req",
      "nm_emp_pm",
      "txt_detail",
    ],
    str_search: "cd_pjt",
    isMultiple: [""],
  },
  POPUP_REL_ISSUE: {
    title: "관련이슈 도움창",
    width: "60%",
    columns: [
      "no_issue_rel",
      "no_issue_rel_title",
      "dt_issue",
      "dt_due",
      "nm_emp",
      "st_issue",
    ],
    str_search: "dc_title",
    isMultiple: [""],
  },
  POPUP_TAXORG_S: {
    title: "세무서코드 도음창",
    columns: ["cd_taxorg", "nm_taxorg", "no_bank"],
    str_search: "cd_taxorg",
  },
  POPUP_GORGH_S: {
    title: "행정동코드 도움창",
    columns: ["cd_gorg", "nm_gorg_h"],
    str_search: "cd_gorg",
  },
  POPUP_GORGB_S: {
    title: "법정동코드 도움창",
    columns: ["cd_gorg", "nm_gorg_b"],
    str_search: "cd_gorg",
  },
  POPUP_TAXLC_S: {
    title: "법인구분(자방세) 도움창",
    columns: ["cd_flag", "nm_flag"],
    str_search: "cd_flag",
  },
  POPUP_IDY_S: {
    title: "주업종코드 도움창",
    columns: ["cd_idy", "nm_mcls", "nm_idy"],
    str_search: "cd_idy",
  },
  POPUP_CLAUSE: {
    title: "검사항목도움창",
    // columns의 0번 index는 code, 1번 index는 name
    width: "65%",
    columns: [
      "cd_clause",
      "nm_clause",
      "dc_unit_cl",
      "yn_insp",
      "dc_lcl",
      "dc_ucl",
      "txt_explain",
      "dc_rmk",
      "yn_sample",
      "cd_sample",
      "no_level",
      "dc_sample",
    ],
    // 팝업 생성 시, 검색창에 자동 입력할 데이터의 key값
    str_search: "cd_clause",
    autoSearch: false,
    isMultiple: [""],
  },
  POPUP_ITEM_SCT: {
    title: "품목도움창",
    width: "65%",
    columns: [
      "cd_item",
      "nm_item",
      "dc_item_spec",
      "dc_item_unit",
      "dc_material",
      "yn_lot",
      "yn_sn",
      "cd_cust_maker",
      "cd_cust_isu",
      "cd_cust_rcv",
      "fg_vat",
      // "um",
    ],
    // 팝업 생성 시, 검색창에 자동 입력할 데이터의 key값
    str_search: "cd_item",
    autoSearch: false,
    isMultiple: ["SN_SAL_SAO_REG_001", "SN_SAL_SAO_REG_001_TEX"],
  },

  POPUP_ITEM_PMS: {
    title: "품목도움창",
    // columns의 0번 index는 code, 1번 index는 name
    width: "65%",
    columns: [
      "cd_item",
      "nm_item",
      "dc_item_spec",
      "dc_item_unit",
      "dc_material",
      "yn_lot",
      "yn_sn",
      "cd_cust_maker",
      "cd_cust_isu",
      "cd_cust_rcv",
      "fg_vat",
      "fg_unit",
      "dc_unit_po",
      "qt_unit_po",
      "tp_item", // 26.03.24 kdy 마이라텍스때 추가
    ],
    // 팝업 생성 시, 검색창에 자동 입력할 데이터의 key값
    str_search: "cd_item",
    autoSearch: false,
    isMultiple: [""],
  },
  POPUP_MTLEST: {
    title: "재고평가도움창",
    width: "65%",
    columns: ["DT_START", "DT_END"],
  },
  POPUP_VARPROPS: {
    title: "변수 속성",
    width: "420px",
    height: "auto",
    // DB 조회 도움창이 아니라 직접 입력 팝업이라 columns의 의미가 다르다.
    // handleReturnFunction이 columns[0]→code, columns[1]→name으로 쓰는데
    // 여기엔 코드/명 쌍이 없으므로 둘 다 id로 맞춰 입력칸에 ID가 표시되게 한다.
    // 나머지 속성(type/default/format)은 onValueChanged의 3번째 인자(rowData)로 넘어간다.
    columns: ["id", "id", "name", "type", "default", "format"],
    // {code}_02 / _03 조회 쿼리가 없는 팝업 — 타이핑 후 blur 시 조회를 시도하지 않는다
    noLookup: true,
  },
};
